import { render, staticRenderFns } from "./ImageWithShadow.vue?vue&type=template&id=0c60a142&scoped=true"
import script from "./ImageWithShadow.vue?vue&type=script&lang=js"
export * from "./ImageWithShadow.vue?vue&type=script&lang=js"
import style0 from "./ImageWithShadow.vue?vue&type=style&index=0&id=0c60a142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60a142",
  null
  
)

export default component.exports